import ValidationErrors from '../fields/validationErrors';
import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { BaseValidator } from './baseValidator';

export class LastNameFieldValidator extends BaseValidator {
    public EULastNameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 255;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'EULastNameLengthRule',
            };
        }
        return null;
    }

    public JPLastNameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 85;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'JPLastNameLengthRule',
            };
        }
        return null;
    }

    constructor(rules = [ValidatorRule.EULastNameLengthRule]) {
        super(rules);
    }
}
